import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'orderby',
    standalone: false
})
export class OrderbyPipe implements PipeTransform {

  transform(list: Array<any>, caption: string): Array<any> {
    return list.sort((x1, x2) => {
        if (x1[caption] > x2[caption])
            return -1;
        else
            return 1;
    })
}

}
